module.exports = __webpack_public_path__ + "img/xddqjp-currency-guide-1.097eb2e6.png";